import React, { useState, useEffect, useRef } from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import ContenuLibre from "../../components/ContenuLibre/contenu-libre"
import {
  zoneActualitesLibreBas,
  zoneActualitesLibreHaut,
  listActualitesContainer,
  actuItem,
  listActus,
  actusFilters,
  actuItemsContainer,
  vocalizedUpdate,
} from "./styles/listActus.module.scss"
import PropTypes from "prop-types"
import {
  ListContainer,
  StyledFade,
  BorderTaxo,
  ContainerLight,
} from "./styled-components/actualites-styled"
import SEO from "../../components/seo"
import ActualiteItem from "./listItems/actualite-item"
import { getPublishedData } from "../../components/get-published-data"
import { getExistingTaxosInItems } from "./utils/get-existing-taxos-in-items"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query {
    allTaxonomyTermThematiques(
      filter: {
        relationships: {
          node__actualites: { elemMatch: { status: { eq: true } } }
        }
      }
    ) {
      ...ListActualitesTaxo
    }
    allNodeActualites(sort: { fields: created, order: DESC }) {
      ...ListActualites
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const ActualitesTemplate = ({ data }) => {
  const pageTitle = "Liste des actualités"
  const allTaxos = data.allTaxonomyTermThematiques.edges
    .map(({ node }) => {
      return node.name
    })
    .join()
  return (
    <Layout message={pageTitle}>
      <SEO
        title={pageTitle}
        description={
          "Dans cette page, vous découvrez toutes les actualités, mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
      />
      <StyledFade childClassName={listActus} delay={150}>
        <section className={zoneActualitesLibreHaut}>
          <ContenuLibre zoneTaxoLibre="zone_actualites_haut" />
        </section>
        <ListContainer className={listActualitesContainer}>
          <RenderActualites actualiteData={data} />
        </ListContainer>
        <section className={zoneActualitesLibreBas}>
          <ContenuLibre zoneTaxoLibre="zone_actualites_bas" />
        </section>
      </StyledFade>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderActualites = ({ actualiteData }) => {
  const [actus, setActus] = useState([])

  useEffect(() => {
    setActus(getPublishedData(actualiteData.allNodeActualites.edges))
  }, [actualiteData])

  return (
    <>
      <Filtres actusData={actus} />
    </>
  )
}

//-----------------------Child component---------------------------//
const Filtres = ({ actusData }) => {
  const relatedTaxos =
    actusData.length > 0 ? getExistingTaxosInItems(actusData) : []
  const [chooseTaxo, setChooseTaxo] = useState("")
  return (
    <>
      <ContainerLight className={actusFilters}>
        <div>
          <h3>Thématique : </h3>
          <ul>
            {relatedTaxos.map((element, index) => {
              let taxoActiveClass = false
              if (chooseTaxo === element) {
                taxoActiveClass = true
              }
              return (
                <li key={index}>
                  <BorderTaxo
                    activeBool={taxoActiveClass}
                    activeText={"#fff"}
                    tabIndex={0}
                    role="button"
                    aria-label={
                      taxoActiveClass
                        ? element + " - Supprimer le filtre actif"
                        : "Filtrer sur la taxonomie '" + element + "'"
                    }
                    onClick={() => {
                      if (chooseTaxo === "" || chooseTaxo !== element) {
                        setChooseTaxo(element)
                      } else if (chooseTaxo === element) {
                        setChooseTaxo("")
                      }
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        if (chooseTaxo === "" || chooseTaxo !== element) {
                          setChooseTaxo(element)
                        } else if (chooseTaxo === element) {
                          setChooseTaxo("")
                        }
                      }
                    }}
                  >
                    {element}
                  </BorderTaxo>
                </li>
              )
            })}
          </ul>
        </div>
      </ContainerLight>
      <FiltreActu actusData={actusData} taxoChoisie={chooseTaxo} />
    </>
  )
}
//-----------------------Sub-Child component---------------------------//
const FiltreActu = ({ actusData, taxoChoisie }) => {
  const observerRef = useRef(null)

  const [numberOfItems, setNumberOfItems] = useState(6)
  let filteredData = []
  filteredData = actusData.reduce((acc, node) => {
    let matchingTaxo = []
    matchingTaxo = node.node.relationships.field_taxonomie_thematique.filter(
      (taxo) => taxo.name === taxoChoisie
    )
    if (matchingTaxo.length > 0) {
      acc.push(node)
    }
    return acc
  }, [])
  filteredData = taxoChoisie === "" ? actusData : filteredData
  let finalFilteredData = undefined
  let othersData = undefined
  finalFilteredData = filteredData.slice(0, numberOfItems)
  othersData = filteredData.slice(numberOfItems)

  const seeMore = () => {
    const actusList = document.getElementById("actus-list")
    const newFocusIndex = actusList.children.length
    setNumberOfItems(numberOfItems + 6)

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          actusList.children[newFocusIndex].querySelectorAll("a")[0].focus()
          if (observerRef.current) {
            observerRef.current.disconnect()
          }
          break
        }
      }
    }

    // Créer une instance de MutationObserver
    if (typeof document !== `undefined`) {
      observerRef.current = new MutationObserver(callback)
      // Démarrer l'observation de l'élément via la ref
      if (actusList) {
        observerRef.current.observe(actusList, {
          childList: true,
          subtree: true,
        })
      }
    }
  }
  return (
    <>
      <section>
        <div>
          <RenderActualitesItems
            actusData={actusData}
            filteredData={finalFilteredData}
          />
        </div>
        {othersData.length > 0 && (
          <div className="voirPlus">
            <span
              role="button"
              tabIndex={0}
              onClick={() => seeMore()}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  seeMore()
                }
              }}
              className="btn"
            >
              Voir plus
            </span>
          </div>
        )}
      </section>
    </>
  )
}
//-----------------------Sub-Child component---------------------------//
const RenderActualitesItems = ({ filteredData }) => {
  if (filteredData.length === 0) {
    return (
      <p
        className={vocalizedUpdate}
        style={{ margin: "0 2rem" }}
        role="status"
        aria-live="polite"
      >
        Pas de contenu à afficher.
      </p>
    )
  }
  return (
    <ul className={actuItemsContainer} id={"actus-list"}>
      <p className={vocalizedUpdate} role="status" aria-live="polite">
        {filteredData.length +
          " actualité" +
          (filteredData.length === 1 ? "" : "s") +
          " affichée" +
          (filteredData.length === 1 ? "" : "s")}
      </p>
      {filteredData.map(({ node, index }) => (
        <li key={index} className={actuItem}>
          <ActualiteItem actu={node} />
        </li>
      ))}
    </ul>
  )
}
//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

ActualitesTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
}
RenderActualitesItems.propTypes = {
  filteredData: PropTypes.array.isRequired,
}
RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
FiltreActu.propTypes = {
  actusData: PropTypes.object.isRequired,
  taxoChoisie: PropTypes.string.isRequired,
  filteredData: PropTypes.array.isRequired,
}
Filtres.propTypes = {
  actusData: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default ActualitesTemplate
